import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router'

@Component({
  selector: 'app-login-error',
  templateUrl: './login-error.component.html',
  styleUrls: ['./login-error.component.css']
})
export class LoginErrorComponent implements OnInit {

  constructor(private readonly router : Router) { }

  ngOnInit() {
    setTimeout(function () {
    this.router.navigate(['/log-out']);
  }.bind(this), 3000);
  }

}
